import {
  updateTemplateSignatoryActionV2,
  deleteTemplateSignerTags,
  createTemplateSignerIdentityAction,
} from "../../../actions/DocumentActions";
import { createTemplateSignatoriesService } from "../../../actions/DocumentTemplateActions/templateService";
import { updateToolPaneData } from "../../../actions/QuotationActions/QuotationActions";
import { TOOLPANE_TTITLE } from "../../../constants/toolpane";

import store from "../../../store";
import AddTemplateComponentCommand from "../addComponentCommandBase/addTemplateComponentCommand";

class AddSignatureTemplateCommand extends AddTemplateComponentCommand {
  constructor(componentData) {
    super(componentData);
    this.componentData = componentData;
  }

  addTemplateSignatoriesService = (templateID, data) =>
    new Promise((resolve, reject) => {
      createTemplateSignatoriesService(templateID, data)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

  addTagWithComponent(docID, data, componentPayload) {
    store.dispatch(updateTemplateSignatoryActionV2(docID, [data])).then(() => {
      super
        .saveToDatabase(componentPayload)
        .then(() => {
          store.dispatch(
            updateToolPaneData(
              true,
              TOOLPANE_TTITLE.DOC_SIGNATURE_COMPONENTS,
              this.componentData.mode,
            ),
          );
        })
        .catch(() => {
          this.deleteSignerTags();
        });
    });
  }

  execute() {
    if (this.isRedo) {
      super.redo();
      const { docID } = this.componentData;
      const componentPayload = super.getComponentPayload();
      store.dispatch(
        updateTemplateSignatoryActionV2(docID, [
          componentPayload.component.content.data,
        ]),
      );
    } else {
      const { docID } = this.componentData;
      // 1.
      super.prepareLayout();
      // 2.
      const activeEditorPayload = this.getActiveEditorPayload();
      // 3.
      super.updateRedux(activeEditorPayload);
      const componentPayload = super.getComponentPayload();
      const {
        component: {
          content: { data },
        },
      } = componentPayload;
      const { signer_identity_id } = data;
      if (signer_identity_id) {
        this.addTagWithComponent(docID, data, componentPayload);
      } else {
        store.dispatch(createTemplateSignerIdentityAction(docID)).then(res => {
          data.signer_identity_id = res.id;
          this.addTagWithComponent(docID, data, componentPayload);
        });
      }
    }
  }

  deleteSignerTags() {
    const { component, docID } = this.componentData;
    const deleteSignatureSectionData = {
      component_id: component.id,
      ids: [component.data.id],
    };

    store.dispatch(deleteTemplateSignerTags(docID, deleteSignatureSectionData));
  }

  undo() {
    super.undo();
    this.deleteSignerTags();
  }
}

export default AddSignatureTemplateCommand;
